import { React, useEffect } from "react";
import "./App.css";

import Root from "./components/root/root.js";
import { LandingPage } from "./page/LandingPage/LandingPage.js";
import { MovieDetailPage } from "./page/DetailsPage/MovieDetailsPage/MovieDetailsPage.js";
import { TvDetailPage } from "./page/DetailsPage/TvDetailsPage/TvDetailsPage.js";
import { RcmPage } from "./page/RcmPage/RcmPage.js";
import { FilterPage } from "./page/FilterPage/FilterPage.js";
import { SearchPage } from "./page/SearchPage/SearchPage.js";
//Redux
import { useDispatch, useSelector } from "react-redux";
import { getApiUtility } from "./utility/apiUtilitySlice.js";

import {
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";
import { SeasonDetailPage } from "./page/DetailsPage/SeasonDetailsPage/SeasonDetailsPage.js";
import { EpisodeDetailPage } from "./page/DetailsPage/EpisodeDetailsPage/EpisodeDetailsPage.js";

const appRouter = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<Root />}>
      <Route path="/" element={<LandingPage />} />
      <Route path="/details" element={<MovieDetailPage />} />
      <Route path="/details/mov/:movieId" element={<MovieDetailPage />} />
      <Route path="/details/tv/:tvId" element={<TvDetailPage/>}/>
      <Route path="/details/tv/:tvId/:seasonId" element={<SeasonDetailPage/>}/>      
      <Route path="/details/tv/:tvId/:seasonId/:episodeId" element={<EpisodeDetailPage/>}/>
      <Route path="/recommendation" element={<RcmPage />} />
      <Route path="/search" element={<SearchPage />} />
      <Route path="/filter" element={<FilterPage />} />
    </Route>
  )
);

function App() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getApiUtility());
  }, [dispatch]);

  let apiUtility = useSelector((state) => state.apiUtility)

  return (
    <div className="App">
      {apiUtility.loading ? (
        <h3>Loading</h3>
      ) : apiUtility.error ? (
        <h3>Error 404</h3>
      ) : (
        <RouterProvider router={appRouter} />
      )}
    </div>
  );
}

export default App;
